import { createField } from "./vessel.section";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    data.fields = createField({ props, data, refs, key, isLoading });
};

export const createForm = () => {
    return {
        name: null,
        // code: null,
        code: null,
        tgross: null,
        tnange: null,
        vesselType: null,
        useType: null,
        licenseIssueDate: null,
        licenseExpireDate: null,
        refBoatLicenseStatus: null,
        licenseNumber: null,
        registrationDate: null,
        lbp: null,
        loa: null,
        deep: null,
        breadth: null,
        vesselOwnerRequests: [],
        attachmentVesselIdentities: [],
        attachmentPositionVesselIdentities: [],
        attachmentHeadVessels: [],
        attachmentFullVessels: [],
    };
};
